export default __webpack_public_path__ + "static/media/600.ab71e4c3.jpg";